import React from 'react';
import {StyleSheet, TouchableOpacity, View, Text} from 'react-native';
import edit_Icon from '../../assets/editIcon.png';
import TableCommonStyleSheet from '../../StyleSheets/TableCommonStyleSheet';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import colors from '../../HelperClasses/AppColor';
import {Gradient} from 'react-gradient';

const SaveButton = ({onClickButton, isDisabled, is_approve = true, title}) => {
  return (
    <View
      style={[
        tableStyle.gradientViewBGStyle,
        {
          borderColor: is_approve ? colors.AppNewGreen : colors.AppRed,
          marginRight: 0,
        },
      ]}>
      <Gradient
        gradients={colors.GradientColors} // required
        property="background"
        gradientType={'linear'}
        duration={2333000}
        angle="0deg">
        <TouchableOpacity onPress={onClickButton}>
          <Text
            style={[
              tableStyle.saveBtnTxtStyle,
              {
                padding: 5,
                paddingLeft: 10,
                paddingRight: 10,
              },
            ]}>
            {title}
          </Text>
        </TouchableOpacity>
      </Gradient>
    </View>
  );
};

export default SaveButton;
